module.exports = __webpack_public_path__ + "static/media/wheatfield.71212979.jpg";